import {
    type ThemeSwitcherIconColorConstantType,
    type ThemeSwitcherDefaultKey,
    type ThemeSwitchVariant
} from "./type";
import {
    Monitor as MonitorIcon,
    Moon as MoonIcon,
    type LucideIcon,
    Sun as SunIcon
} from "lucide-react-native";
import {
    getButtonCustomColor
} from "../button/stylesheet";

export const THEME_SWITCHER_DEFAULT_KEYS: Array<ThemeSwitcherDefaultKey> = [
    "light",
    "dark",
    "system"
];

export const THEME_SWITCHER_ICONS: Record<ThemeSwitcherDefaultKey, LucideIcon> = {
    system: MonitorIcon,
    light: SunIcon,
    dark: MoonIcon
};

export const THEME_SWITCHER_TITLE_KEYS: Record<ThemeSwitcherDefaultKey, keyof NCoreUIKit.Translation> = {
    system: "theme-switcher-system",
    light: "theme-switcher-light",
    dark: "theme-switcher-dark"
};

export const THEME_SWITCHER_ICON_COLORS: Record<ThemeSwitcherDefaultKey, NonNullable<ThemeSwitchVariant["iconColor"]>> = {
    system: "default",
    light: "sun",
    dark: "moon"
};

export const getThemeSwitcherIconColor = ({
    isCustomIconColor,
    buttonIconColor,
    isDisabled,
    iconColor,
    colors
}: ThemeSwitcherIconColorConstantType): string | undefined => {
    if(isDisabled || isCustomIconColor || !iconColor) {
        return buttonIconColor;
    }

    return getButtonCustomColor({
        tokenColors: colors.content.icon,
        customColor: iconColor,
        colors
    });
};
